import React from "react";
import { Heart } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const SIZES = {
  sm: { btn: "h-6 px-1.5 gap-1 text-[11px]", icon: "w-3.5 h-3.5" },
  md: { btn: "h-9 px-3 gap-1.5 text-sm", icon: "w-4.5 h-4.5" },
};

/** ❤️ toggle with counter. `dark` = on the lightbox backdrop. */
export default function LikeButton({ item, onToggle, size = "sm", dark = false, className = "" }) {
  const { t } = useLang();
  const s = SIZES[size];
  const liked = !!item.liked_by_me;
  const base = dark
    ? liked ? "bg-rose-500 text-white" : "bg-sand/15 text-sand hover:bg-sand/30"
    : liked ? "bg-rose-500 text-white border-rose-500" : "bg-card/90 text-ink border-stoneLine hover:border-rose-400 hover:text-rose-500";
  return (
    <button type="button" onClick={(e) => { e.stopPropagation(); onToggle(item.id); }}
      aria-pressed={liked} aria-label={liked ? t("unlike") : t("like")} title={liked ? t("unlike") : t("like")}
      data-testid={`like-btn-${item.id}`}
      className={`inline-flex items-center rounded-full border backdrop-blur-sm font-semibold transition-colors active:scale-95 ${s.btn} ${dark ? "border-transparent" : ""} ${base} ${className}`}>
      <Heart className={`${s.icon} transition-transform ${liked ? "scale-110" : ""}`} fill={liked ? "currentColor" : "none"} />
      <span data-testid={`like-count-${item.id}`}>{item.likes || 0}</span>
    </button>
  );
}
